import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';

interface SectionProps {
  name: string;
  backgroundColor?: string;
  customWidth?: string;
  children: ReactNode;
  marginBottom?: string;
}

const SectionContainer = styled('section')<{ backgroundColor?: string, marginBottom?: string }>(({ backgroundColor, marginBottom }) => ({
  width: '99.6vw',
  backgroundColor: backgroundColor || 'transparent',
  position: 'relative',
  left: '50%',
  right: '50%',
  marginLeft: '-50vw',
  marginRight: '-50vw',
  marginBottom: marginBottom || '0',

  '@media (max-width: 1024px)': {
    width: '100%',
    marginLeft: '0',
    marginRight: '0',
    left: 'auto',
    right: 'auto',
  }
}));

const SectionContent = styled('div')<{ customWidth?: string }>(({ customWidth }) => ({
  width: '100%',
  maxWidth: customWidth || '920px',
  margin: '0 auto',
  padding: '0'
}));

export const Section = ({ name, backgroundColor, customWidth, children, marginBottom }: SectionProps) => {
  return (
    <SectionContainer backgroundColor={backgroundColor} id={name} marginBottom={marginBottom} >
      <SectionContent customWidth={customWidth}>
        {children}
      </SectionContent>
    </SectionContainer>
  );
}; 